module.exports = __webpack_public_path__ + "static/img/payway4.e317a66.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newdownload/payway4.png
// module id = W3SJ
// module chunks = 0